<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
            <div class="md:flex md:items-center md:justify-between">
                <div class="flex-1 min-w-0">
                    <h1 class="py-0.5 text-2xl font-semibold text-gray-900">{{ $t('Tickets & SLA') }}</h1>
                </div>
                <div class="mt-4 flex md:mt-0 md:ml-4">
                    <router-link
                        class="btn btn-blue shadow-sm rounded-md"
                        to="/dashboard/admin/settings"
                    >
                        {{ $t('Back') }}
                    </router-link>
                </div>
            </div>
        </div>
        <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div class="my-6">
                <loading :status="loading"/>
                <form @submit.prevent="save">
                    <div class="shadow sm:rounded-md sm:overflow-hidden">
                        <div class="px-4 py-5 bg-white sm:p-6">
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3">
                                    <h3 class="text-lg font-medium leading-6 text-gray-900">{{ $t('Auto-close') }}</h3>
                                    <p class="mt-1 text-sm text-gray-500">{{ $t('Automatically close inactive tickets') }}</p>
                                </div>
                                <div class="col-span-3 sm:col-span-1">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="auto_close_days">
                                        {{ $t('Auto-close after (days)') }}
                                    </label>
                                    <div class="mt-1 relative rounded-md shadow-sm">
                                        <input
                                            id="auto_close_days"
                                            v-model="auto_close_days"
                                            class="form-input block w-full sm:text-sm sm:leading-5"
                                            min="0"
                                            max="365"
                                            required
                                            type="number"
                                        >
                                    </div>
                                    <p class="mt-1 text-xs text-gray-500">
                                        {{ $t('Number of days of inactivity after the last staff reply before a ticket is auto-closed. Set to 0 to disable.') }}
                                    </p>
                                </div>
                                <div class="col-span-3 mt-4">
                                    <h3 class="text-lg font-medium leading-6 text-gray-900">{{ $t('SLA') }}</h3>
                                    <p class="mt-1 text-sm text-gray-500">{{ $t('Service Level Agreement settings') }}</p>
                                </div>
                                <div class="col-span-3 sm:col-span-1">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="sla_response_hours">
                                        {{ $t('SLA response time (hours)') }}
                                    </label>
                                    <div class="mt-1 relative rounded-md shadow-sm">
                                        <input
                                            id="sla_response_hours"
                                            v-model="sla_response_hours"
                                            class="form-input block w-full sm:text-sm sm:leading-5"
                                            min="0"
                                            max="720"
                                            required
                                            type="number"
                                        >
                                    </div>
                                    <p class="mt-1 text-xs text-gray-500">
                                        {{ $t('If no staff response within this time, a warning indicator will appear in the ticket list. Set to 0 to disable.') }}
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="px-4 py-3 bg-gray-100 text-right sm:px-6">
                            <div class="inline-flex">
                                <button class="btn btn-green rounded-md shadow-sm" type="submit">
                                    {{ $t('Save settings') }}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: "tickets-settings",
    data() {
        return {
            loading: true,
            auto_close_days: 7,
            sla_response_hours: 24,
        }
    },
    mounted() {
        this.get();
    },
    methods: {
        get() {
            const self = this;
            axios.get('api/dashboard/admin/settings/tickets').then(function (response) {
                self.auto_close_days = response.data.auto_close_days || 0;
                self.sla_response_hours = response.data.sla_response_hours || 0;
                self.loading = false;
            }).catch(function () {
                self.$router.push('/dashboard/admin/settings');
            });
        },
        save() {
            const self = this;
            self.loading = true;
            axios.post('api/dashboard/admin/settings/tickets', {
                auto_close_days: self.auto_close_days,
                sla_response_hours: self.sla_response_hours,
            }).then(function () {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Settings updated successfully').toString(),
                    type: 'success'
                });
            }).catch(function () {
                self.loading = false;
            });
        }
    }
}
</script>
